"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var ContentValidationService = /** @class */ (function () {
    function ContentValidationService() {
        this.schemaForGetContentMenus = joi_1.default.object().keys({}).unknown(true);
        this.schemaForGetContentHome = joi_1.default.object().keys({}).unknown(true);
        this.schemaForGetContentPage = joi_1.default.object().keys({
            pageSlug: joi_1.default.string().required()
        });
        this.schemaForGetContentPageById = joi_1.default.object().keys({
            pageId: joi_1.default.number().required()
        });
    }
    ContentValidationService.prototype.getContentMenusData = function (data) {
        var error = this.schemaForGetContentMenus.validate(data).error;
        // debug
        console.debug('Validating get content menus data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ContentValidationService.prototype.getContentHomeData = function (data) {
        var error = this.schemaForGetContentHome.validate(data).error;
        // debug
        console.debug('Validating get content home data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ContentValidationService.prototype.getContentPageData = function (data) {
        var error = this.schemaForGetContentPage.validate(data).error;
        // debug
        console.debug('Validating get content page data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ContentValidationService.prototype.getContentPageByIdData = function (data) {
        var error = this.schemaForGetContentPageById.validate(data).error;
        // debug
        console.debug('Validating get content page by id data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return ContentValidationService;
}());
exports.ContentValidationService = ContentValidationService;
//# sourceMappingURL=ContentValidationService.js.map